import { useTranslation } from 'react-i18next';
import MonthlyReportView from '../MonthlyReportView';

export default function DistributorReportsPage() {
  const { t } = useTranslation();
  return (
    <MonthlyReportView
      title={t('distributor.reportsTitle')}
      queryKey={['distributor', 'reports', 'monthly']}
      reportUrl="/distributor/reports/monthly"
      multi
      exportUrl="/distributor/reports/monthly/export"
      exportFilename="distributor-monthly.csv"
    />
  );
}
